/**
 * @generated SignedSource<<c3fb1848899004cf7f5720a47610b581>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment$data = {
  readonly issueByKey: {
    readonly childIssues: {
      readonly __typename: "JiraChildIssuesWithinLimit";
      readonly issues: {
        readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel">;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
    readonly hierarchyLevelBelow: {
      readonly level: number | null | undefined;
    } | null | undefined;
    readonly projectField: {
      readonly project: {
        readonly key: string;
        readonly projectType: JiraProjectType | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment";
};
export type view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment$key = {
  readonly " $data"?: view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    }
  ],
  "kind": "Fragment",
  "name": "view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "issueKey"
        }
      ],
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issueByKey",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraProjectField",
          "kind": "LinkedField",
          "name": "projectField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "key"
                },
                {
                  "kind": "ScalarField",
                  "name": "projectType"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueTypeHierarchyLevel",
          "kind": "LinkedField",
          "name": "hierarchyLevelBelow",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "level"
            }
          ]
        },
        {
          "kind": "LinkedField",
          "name": "childIssues",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "activeIssuesOnly",
                      "value": true
                    },
                    {
                      "kind": "Literal",
                      "name": "activeProjectsOnly",
                      "value": true
                    }
                  ],
                  "concreteType": "JiraIssueConnection",
                  "kind": "LinkedField",
                  "name": "issues",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "progressSummary_issueViewChildIssuesPanel"
                    }
                  ],
                  "storageKey": "issues(activeIssuesOnly:true,activeProjectsOnly:true)"
                }
              ],
              "type": "JiraChildIssuesWithinLimit"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "91708ed77f8761ca5198def911f2f80e";

export default node;
